import { render, staticRenderFns } from "./VoucherCard.vue?vue&type=template&id=1126e48c&"
import script from "./VoucherCard.vue?vue&type=script&lang=js&"
export * from "./VoucherCard.vue?vue&type=script&lang=js&"
import style0 from "./VoucherCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports